import React, { useState, useEffect } from "react";
import { fetchSettings } from "../utils/settingsApi";
import { saveQuery } from "../utils/queriesApi";

export default function Contact() {
  const [settings, setSettings] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ type: "", message: "" });

  useEffect(() => {
     fetchSettings().then(data => setSettings(data));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      setStatus({ type: "danger", message: "Please fill in all fields." });
      return;
    }

    setLoading(true);
    setStatus({ type: "info", message: "Sending message..." });

    try {
      await saveQuery(formData);
      setStatus({ type: "success", message: "Your message has been sent successfully!" });
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error sending message:", error);
      setStatus({ type: "danger", message: `Failed to send message: ${error.message || 'Unknown error'}` });
    } finally {
      setLoading(false);
    }
  };

  const addresses = settings?.addresses ? settings.addresses.split('\n') : [];
  const emails = settings?.emails ? settings.emails.split('\n') : [];
  const phones = settings?.phones ? settings.phones.split('\n') : [];

  return (
    <div>
      <div className="container-fluid pt-5">
        <div className="container">
          <div className="text-center pb-2">
            <p className="section-title px-5">
              <span className="px-2">Get In Touch</span>
            </p>
            <h1 className="mb-4">Contact Us For Any Query</h1>
          </div>
          <div className="row">
            <div className="col-lg-7 mb-5">
              <div className="contact-form">
                {status.message && (
                  <div className={`alert alert-${status.type}`}>
                    {status.message}
                  </div>
                )}
                <form
                  name="sentMessage"
                  id="contactForm"
                  noValidate="novalidate"
                  onSubmit={handleSubmit}
                >
                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Your Name"
                      required="required"
                      value={formData.name}
                      onChange={handleChange}
                      data-validation-required-message="Please enter your name"
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div className="control-group">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Your Email"
                      required="required"
                      value={formData.email}
                      onChange={handleChange}
                      data-validation-required-message="Please enter your email"
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div className="control-group">
                    <input
                      type="text"
                      className="form-control"
                      id="subject"
                      placeholder="Subject"
                      required="required"
                      value={formData.subject}
                      onChange={handleChange}
                      data-validation-required-message="Please enter a subject"
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div className="control-group">
                    <textarea
                      className="form-control"
                      rows={6}
                      id="message"
                      placeholder="Message"
                      required="required"
                      value={formData.message}
                      onChange={handleChange}
                      data-validation-required-message="Please enter your message"
                    />
                    <p className="help-block text-danger" />
                  </div>
                  <div>
                    <button
                      className="btn btn-primary py-2 px-4"
                      type="submit"
                      id="sendMessageButton"
                      disabled={loading}
                    >
                      {loading ? "Sending..." : "Send Message"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="col-lg-5 mb-5">
              <p>
                For any kind of query and clarification please contact with us
                without any hesitation.
              </p>
              <div className="d-flex">
                <i
                  className="fa fa-map-marker-alt d-inline-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                  style={{ width: 45, height: 45 }}
                />
                <div className="pl-3">
                  <h5>Address</h5>
                  {addresses.length > 0 ? addresses.map((addr, i) => <p key={i} className="mb-0">{addr}</p>) : <p>Loading...</p>}
                </div>
              </div>
              <div className="d-flex">
                <i
                  className="fa fa-envelope d-inline-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                  style={{ width: 45, height: 45 }}
                />
                <div className="pl-3 mt-3">
                  <h5>Email</h5>
                  {emails.length > 0 ? emails.map((email, i) => <p key={i} className="mb-0">{email}</p>) : <p>Loading...</p>}
                </div>
              </div>
              <div className="d-flex">
                <i
                  className="fa fa-phone-alt d-inline-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                  style={{ width: 45, height: 45 }}
                />
                <div className="pl-3 mt-3">
                  <h5>Phone</h5>
                  {phones.length > 0 ? phones.map((phone, i) => <p key={i} className="mb-0">{phone}</p>) : <p>Loading...</p>}
                </div>
              </div>
              <div className="d-flex">
                <i
                  className="far fa-clock d-inline-flex align-items-center justify-content-center bg-primary text-white rounded-circle"
                  style={{ width: 45, height: 45 }}
                />
                <div className="pl-3">
                  <h5>Opening Hours</h5>
                  <strong>Mon - Friday:</strong>
                  <p className="m-0">08:00 AM - 05:30 PM </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
